// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"6121dcf6","86":"464726d2","129":"3e6f6628","131":"7d3cc5ab","134":"c235d28d","248":"27691e28","362":"5009a51b","386":"09216ed1","773":"f794876f","801":"4441693a","806":"5d0ca597","906":"3f0e163c"}[chunkId] + ".chunk.js";
};